/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { ServiceType } from 'shared';

export enum UpdateClusterActions {
  OPEN_UPDATE_CLUSTER_OVERLAY = 'OPEN_UPDATE_CLUSTER_OVERLAY',
  CLOSE_UPDATE_CLUSTER_OVERLAY = 'CLOSE_UPDATE_CLUSTER_OVERLAY',
}

export type UpdateClusterState = {
  serviceType: ServiceType;
};

export type UpdateClusterParams = {
  serviceType: ServiceType;
};

export type OpenUpdateClusterOverlayAction = {
  type: UpdateClusterActions.OPEN_UPDATE_CLUSTER_OVERLAY;
  payload: {
    serviceType: ServiceType;
  };
};

export type CloseUpdateClusterOverlayAction = {
  type: UpdateClusterActions.CLOSE_UPDATE_CLUSTER_OVERLAY;
};

export type UpdateClusterActionTypes = OpenUpdateClusterOverlayAction | CloseUpdateClusterOverlayAction;
